webpackJsonp([213534597649335],{

/***/ "./src/components/Banner/Banner.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/Banner/Banner.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/components/Banner/Banner.css");
	
	var _saastopossu = __webpack_require__("./src/components/Banner/saastopossu.svg");
	
	var _saastopossu2 = _interopRequireDefault(_saastopossu);
	
	var _reactGridSystem = __webpack_require__("./node_modules/react-grid-system/build/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Info = function (_Component) {
	  _inherits(Info, _Component);
	
	  function Info() {
	    _classCallCheck(this, Info);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Info.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "banner" },
	      _react2.default.createElement(
	        _reactGridSystem.Container,
	        null,
	        _react2.default.createElement(
	          _reactGridSystem.Row,
	          null,
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { md: 7 },
	            _react2.default.createElement(
	              "span",
	              { className: "banner-first" },
	              "Lainaa hakemassa?"
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "banner-second" },
	              "Laina-apu kertoo kaiken oleellisen lainatuotteista ja mist\xE4 voit hakea lainaa."
	            )
	          ),
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { md: 5 },
	            _react2.default.createElement("img", { src: _saastopossu2.default, alt: "Saastopossu", className: "banner-img" })
	          )
	        )
	      )
	    );
	  };
	
	  return Info;
	}(_react.Component);
	
	exports.default = Info;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Banner/saastopossu.svg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/saastopossu.1add2db8.svg";

/***/ }),

/***/ "./src/components/Home/Home.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/Home/Home.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Toplist = __webpack_require__("./src/components/Toplist/Toplist.jsx");
	
	var _Toplist2 = _interopRequireDefault(_Toplist);
	
	__webpack_require__("./src/components/Home/Home.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "home" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Tervetuloa Laina-apu.fi sivustolle."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Laina-apu auttaa lainan hakemisessa. Lue ",
	        _react2.default.createElement(
	          "a",
	          { href: "/blogi/", title: "Laina-apu blogi" },
	          "Laina-apu blogista"
	        ),
	        " viimeisimm\xE4t vinkit laina-asioihin tai katso sivustolle viimeksi lis\xE4tyt ",
	        _react2.default.createElement(
	          "a",
	          { href: "/lainat/", title: "Lainatarjoukset" },
	          "lainatarjoukset"
	        ),
	        "."
	      ),
	      _react2.default.createElement(_Toplist2.default, null),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Opi lis\xE4\xE4 lainoista"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Laina-apu auttaa tutustumaan eri lainatuotteisiin ja siihen, mit\xE4 ne pit\xE4v\xE4t sis\xE4ll\xE4\xE4n ja mitk\xE4 ovat niiden kulut. N\xE4in ollen osaat tehd\xE4 p\xE4\xE4t\xF6ksen siit\xE4, mik\xE4 on paras lainamuoto sinulle ja sinun tilanteeseesi. Lainoja on olemassa monenlaisia ja niit\xE4 tarvitaan eri tilanteisiin. Laina apu pyrkii auttamaan sinua tiet\xE4m\xE4\xE4n lis\xE4\xE4 siit\xE4, mik\xE4 laina sopii parhaiten sinun tilanteeseesi."
	      )
	    );
	  };
	
	  return Home;
	}(_react.Component);
	
	exports.default = Home;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/PostListing/Listing.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/PostListing/PostListing.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactGridSystem = __webpack_require__("./node_modules/react-grid-system/build/index.js");
	
	__webpack_require__("./src/components/PostListing/Listing.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostListing = function (_React$Component) {
	  _inherits(PostListing, _React$Component);
	
	  function PostListing() {
	    _classCallCheck(this, PostListing);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostListing.prototype.getPostList = function getPostList() {
	    var postList = [];
	    this.props.postEdges.forEach(function (postEdge) {
	      postList.push({
	        path: postEdge.node.fields.slug,
	        tags: postEdge.node.frontmatter.tags,
	        cover: postEdge.node.frontmatter.cover,
	        title: postEdge.node.frontmatter.title,
	        date: postEdge.node.frontmatter.date,
	        excerpt: postEdge.node.excerpt,
	        timeToRead: postEdge.node.timeToRead
	      });
	    });
	    return postList;
	  };
	
	  PostListing.prototype.render = function render() {
	    var postList = this.getPostList();
	    return _react2.default.createElement(
	      _reactGridSystem.Row,
	      null,
	      /* Your post list here. */
	      postList.map(function (post) {
	        return _react2.default.createElement(
	          _reactGridSystem.Col,
	          { md: 4 },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.path, key: post.title },
	            _react2.default.createElement("img", { src: post.cover })
	          ),
	          _react2.default.createElement(
	            "h3",
	            { className: "feed-title" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: post.path, key: post.title },
	              post.title
	            )
	          )
	        );
	      })
	    );
	  };
	
	  return PostListing;
	}(_react2.default.Component);
	
	exports.default = PostListing;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/SEO/SEO.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__("./data/SiteConfig.js");
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	      description = postMeta.description ? postMeta.description : postNode.excerpt;
	      image = postMeta.cover;
	      postURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix + postPath;
	    } else {
	      title = _SiteConfig2.default.siteTitle;
	      description = _SiteConfig2.default.siteDescription;
	      image = _SiteConfig2.default.siteLogo;
	    }
	    var realPrefix = _SiteConfig2.default.pathPrefix === "/" ? "" : _SiteConfig2.default.pathPrefix;
	    image = _SiteConfig2.default.siteUrl + realPrefix + image;
	    var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      "@context": "http://schema.org",
	      "@type": "WebSite",
	      url: blogURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : ""
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        "@context": "http://schema.org",
	        "@type": "BreadcrumbList",
	        itemListElement: [{
	          "@type": "ListItem",
	          position: 1,
	          item: {
	            "@id": postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        "@context": "http://schema.org",
	        "@type": "BlogPosting",
	        url: blogURL,
	        name: title,
	        alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : "",
	        headline: title,
	        image: {
	          "@type": "ImageObject",
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { name: "description", content: description }),
	      _react2.default.createElement("meta", { name: "image", content: image }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement("meta", { property: "og:url", content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement("meta", { property: "og:type", content: "article" }) : null,
	      _react2.default.createElement("meta", { property: "og:title", content: title }),
	      _react2.default.createElement("meta", { property: "og:description", content: description }),
	      _react2.default.createElement("meta", { property: "og:image", content: image }),
	      _react2.default.createElement("meta", {
	        property: "fb:app_id",
	        content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : ""
	      }),
	      _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	      _react2.default.createElement("meta", {
	        name: "twitter:creator",
	        content: _SiteConfig2.default.userTwitter ? _SiteConfig2.default.userTwitter : ""
	      }),
	      _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	      _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	      _react2.default.createElement("meta", { name: "twitter:image", content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Toplist/Toplist.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/Toplist/Toplist.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactGridSystem = __webpack_require__("./node_modules/react-grid-system/build/index.js");
	
	__webpack_require__("./src/components/Toplist/Toplist.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toplist = function (_React$Component) {
	  _inherits(Toplist, _React$Component);
	
	  function Toplist() {
	    _classCallCheck(this, Toplist);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Toplist.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactGridSystem.Container,
	      null,
	      _react2.default.createElement(
	        _reactGridSystem.Row,
	        null,
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Laina-avun poiminnat"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Laina-apu listaa vain luotettavia toimijoita ja lis\xE4\xE4 uusia lainanantajia tarkkaan seulomalla. Klikkaamalla kuvaa p\xE4\xE4set tutustumaan tarkemmin kyseiseen toimijaan."
	        ),
	        _react2.default.createElement(
	          _reactGridSystem.Row,
	          null,
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { lg: 3 },
	            _react2.default.createElement(
	              "a",
	              { href: "/arkadia-rahoitus-lainaa-500-50-000-euroa" },
	              _react2.default.createElement("img", { className: "toplist-img", src: "/img/arkadiarahoitus-lainaa-logo.jpg" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { lg: 3 },
	            _react2.default.createElement(
	              "h3",
	              { className: "toplist-title" },
	              "Arkadirahoitus"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "toplist" },
	              _react2.default.createElement(
	                "li",
	                null,
	                "Kulutusluotto"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "500 - 50 000 euroa"
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { className: "btn", href: "/mene/arkadiarahoitus.html", target: "_blank", rel: "nofollow" },
	              "Hae lainaa"
	            )
	          ),
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { lg: 3 },
	            _react2.default.createElement(
	              "a",
	              { href: "/luotto-raha-hae-heti-2000-\u20AC-lainaa" },
	              _react2.default.createElement("img", { className: "toplist-img", src: "/img/luottoraha-lainaa-logo.jpg" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { lg: 3 },
	            _react2.default.createElement(
	              "h3",
	              { className: "toplist-title" },
	              "Luottoraha"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "toplist" },
	              _react2.default.createElement(
	                "li",
	                null,
	                "Joustava kulutusluottoa"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "2000\u20AC jatkuva luotto"
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { className: "btn", href: "/mene/luottoraha.html", target: "_blank", rel: "nofollow" },
	              "Hae lainaa"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactGridSystem.Row,
	          null,
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { lg: 3 },
	            _react2.default.createElement(
	              "a",
	              { href: "ok-money-hae-heti-lainaa" },
	              _react2.default.createElement("img", { className: "toplist-img", src: "/img/okmoney-lainaa-logo.jpg" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { lg: 3 },
	            _react2.default.createElement(
	              "h3",
	              { className: "toplist-title" },
	              "OK Money"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "toplist" },
	              _react2.default.createElement(
	                "li",
	                null,
	                "Kulutusluotto"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "2 100 \u20AC"
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { className: "btn", href: "/mene/okmoney.html", target: "_blank", rel: "nofollow" },
	              "Hae lainaa"
	            )
	          ),
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { lg: 3 },
	            _react2.default.createElement(
	              "a",
	              { href: "lainasto" },
	              _react2.default.createElement("img", { className: "toplist-img", src: "/img/lainasto-lainaa.jpg" })
	            )
	          ),
	          _react2.default.createElement(
	            _reactGridSystem.Col,
	            { lg: 3 },
	            _react2.default.createElement(
	              "h3",
	              { className: "toplist-title" },
	              "Lainasto.fi"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "toplist" },
	              _react2.default.createElement(
	                "li",
	                null,
	                "Pikalaina"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Lainaa 100 - 3 000 euroa"
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { className: "btn", href: "/mene/lainasto.html", target: "_blank", rel: "nofollow" },
	              "Hae lainaa"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Toplist;
	}(_react2.default.Component);
	
	exports.default = Toplist;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/mikakujapelto/mikakujapelto/projektit/laina-apu/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/mikakujapelto/mikakujapelto/projektit/laina-apu/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/mikakujapelto/mikakujapelto/projektit/laina-apu/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/mikakujapelto/mikakujapelto/projektit/laina-apu/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/mikakujapelto/mikakujapelto/projektit/laina-apu/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/mikakujapelto/mikakujapelto/projektit/laina-apu/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/mikakujapelto/mikakujapelto/projektit/laina-apu/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostListing = __webpack_require__("./src/components/PostListing/PostListing.jsx");
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _SEO = __webpack_require__("./src/components/SEO/SEO.jsx");
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Home = __webpack_require__("./src/components/Home/Home.jsx");
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Banner = __webpack_require__("./src/components/Banner/Banner.jsx");
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _SiteConfig = __webpack_require__("./data/SiteConfig.js");
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _reactGridSystem = __webpack_require__("./node_modules/react-grid-system/build/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    return _react2.default.createElement(
	      "div",
	      { className: "index-container" },
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_Banner2.default, null),
	      _react2.default.createElement(
	        _reactGridSystem.Container,
	        null,
	        _react2.default.createElement(_Home2.default, null),
	        _react2.default.createElement(_SEO2.default, { postEdges: postEdges }),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Viimeisimm\xE4t kirjoitukset"
	        ),
	        _react2.default.createElement(_PostListing2.default, { postEdges: postEdges }),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Miksi hakea lainaa?"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Ihmiset hakevat lainaa monista syist\xE4 ja t\xE4m\xE4n takia lainojakin on olemassa useita erilaisia. Laina apu auttaa valitsemaan sinulle sopivimman lainan ja lainantajan. K\xE4ytt\xE4m\xE4ll\xE4 lainanv\xE4litt\xE4j\xE4\xE4 voit my\xF6s samanaikaisesti kilpailuttaa lainan usealla eri toimijalla. Tunnettujja lainoja ovat mm:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Asuntolaina"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Pikavippi"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Kulutusluotto"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Autolaina"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Vertaislaina"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Useimmissa tapauksissa, ellei aina, asuntolaina on aina edullisin laina, jonka yksitt\xE4inen kuluttaja voi ottaa. T\xE4m\xE4 johtuu yksinkertaisesti siit\xE4, ett\xE4 asuntolainassa vakuusasia on kunnossa. Asunto takaa lainaa. Koko lainasummaa asuntokaan ei kuitenkaan takaa, useimmissa tilanteissa asunto takaa noin 70% ostohinnasta. Muut lainat my\xF6nnet\xE4\xE4n l\xE4hes aina heikommalla korolla, sill\xE4 vakuudet eiv\xE4t ole yht\xE4 vahvat. Pikavipit, vertaislainat sek\xE4 muut pikalainat ovat yleens\xE4 hyvin pitk\xE4lti kulutusluottoa. Ovathan ne kaikki kuitenkin lainaa, joka ohjautuu enemm\xE4n tai v\xE4hemm\xE4n suoraan kulutukseen. N\xE4in ollen niiden hintakin on korkeampi kuin esimerkiksi asuntolainassa. Toki on muistettava, ett\xE4 n\xE4m\xE4 niin kutsut pikalainat my\xF6s maksetaan nopeammin takaisin kuin asuntolaina, joka yleens\xE4 otetaan v\xE4hint\xE4\xE4n 20 vuodeksi eteenp\xE4in. Pikalainoja otetaan esimerkiksi silloin, kuin halutaan k\xE4yd\xE4 lomalla ",
	          _react2.default.createElement(
	            "a",
	            { target: "_blank", rel: "noopener", href: "https://www.ulkomailla.fi/" },
	            "ulkomailla"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Kuka voi hakea lainaa?"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Melkeinp\xE4 kaikilla suomalaisilla lainanantajilla on edelletys, ett\xE4 lainanhakija on suomalainen tai asuu vakituisesti Suomessa. Mik\xE4li asut ulkomailla, et voi hakea lainaa Suomessa tai suomalaisilta toimijoilta. Lis\xE4ksi moni lainanantaja edellytt\xE4\xE4 seuraavia asioita:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "V\xE4hint\xE4\xE4n 18-vuoden ik\xE4\xE4 - Usea toimija voi edellytt\xE4\xE4 my\xF6s 20 vuoden ik\xE4\xE4"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "K\xE4yt\xF6ss\xE4 oleva matkapuhelinliittym\xE4 ja s\xE4hk\xF6posti"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Moitteetonta maksuk\xE4ytt\xE4ytymist\xE4. Maksuh\xE4iri\xF6merkint\xF6j\xE4 ei saa olla."
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Edell\xE4 mainitut esimerkit ovat kuitenkin vain suuntaa antavia. Maksuh\xE4iri\xF6merkint\xF6j\xE4 omaava henkil\xF6 pystyy hakemaan ja saaamaankin lainaa mik\xE4li lainan vastineeksi voidaan laittaa jokin vakuus, esimerkiksi asunto."
	        )
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	
	/* eslint no-undef: "off"*/
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-6d1418ba61b95be7a2bd.js